var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "580px",
    height: "184px",
    viewBox: "0 0 580 184",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9862918%",
    y1: "50.0469565%",
    x2: "-0.031598513%",
    y2: "50.0469565%",
    id: "linearGradient-evcadxyh_c-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD1F6D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.5,47.7 C579.5,51.1 576.7,53.9 573.3,53.9 C569.9,53.9 567.1,51.1 567.1,47.7 C567.1,44.3 569.9,41.5 573.3,41.5 C576.7,41.5 579.5,44.3 579.5,47.7 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "568.1 124.3 578.4 124.3 578.4 68 568.1 68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.7,113.9 C520.9,113.9 512.9,105.9 512.9,96.1 C512.9,86.3 520.9,78.3 530.7,78.3 C540.5,78.3 548.5,86.3 548.5,96.1 L548.5,96.1 C548.5,106 540.6,113.9 530.7,113.9 Z M558.9,96.1 L558.9,68 L548.6,68 L548.6,74.3 C543.7,70.3 537.6,68 530.8,68 C515.3,68 502.7,80.6 502.7,96.2 C502.7,111.8 515.3,124.4 530.8,124.4 C537.6,124.4 543.8,122 548.6,118.1 L548.6,124.4 L558.9,124.4 L558.9,96.1 L558.9,96.1 L558.9,96.1 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.3,118.1 C497.3,121.5 494.5,124.3 491.1,124.3 C487.7,124.3 484.9,121.5 484.9,118.1 C484.9,114.7 487.7,111.9 491.1,111.9 C494.5,111.9 497.3,114.6 497.3,118.1 Z",
    id: "Path",
    fill: "#FD1F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5,113.9 C436.7,113.9 428.7,105.9 428.7,96.1 C428.7,86.3 436.7,78.3 446.5,78.3 C456.3,78.3 464.3,86.3 464.3,96.1 C464.3,106 456.3,113.9 446.5,113.9 Z M464.3,74.3 C459.5,70.3 453.3,68 446.5,68 C431,68 418.4,80.6 418.4,96.2 C418.4,111.8 431,124.4 446.5,124.4 C453.3,124.4 459.5,122 464.3,118.1 L464.3,124.4 L474.6,124.4 L474.6,68.1 L464.3,68.1 L464.3,74.3 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "401.5 41.5 391.2 41.5 391.2 68 377.7 68 377.7 78.3 391.2 78.3 391.2 124.3 401.5 124.3 401.5 78.3 415 78.3 415 68 401.5 68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,113.9 C330.7,113.9 322.7,105.9 322.7,96.1 C322.7,86.3 330.7,78.3 340.5,78.3 C350.3,78.3 358.3,86.3 358.3,96.1 C358.3,106 350.3,113.9 340.5,113.9 Z M358.3,74.3 C353.4,70.3 347.3,68 340.5,68 C325,68 312.3,80.6 312.3,96.2 C312.3,111.8 324.9,124.4 340.5,124.4 C347.3,124.4 353.5,122 358.3,118.1 L358.3,124.4 L368.7,124.4 L368.7,68.1 L358.3,68.1 L358.3,74.3 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,113.9 C266.7,113.9 258.7,105.9 258.7,96.1 C258.7,86.3 266.7,78.3 276.5,78.3 C286.3,78.3 294.3,86.3 294.3,96.1 C294.3,106 286.3,113.9 276.5,113.9 Z M294.3,74.3 C289.4,70.3 283.3,68 276.5,68 C261,68 248.3,80.6 248.3,96.2 C248.3,111.8 260.9,124.4 276.5,124.4 C283.3,124.4 289.5,122 294.3,118.1 L294.3,124.4 L304.6,124.4 L304.6,41.6 L294.3,41.6 L294.3,74.3 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,0.1 L0.1,74.2 L0,74.3 L107.5,183.9 L107.6,184 L215.1,74.4 L215.2,74.3 L142.4,0.1 L142.3,0 L72.8,0 L72.8,0.1 Z M83.6,9.2 L131.4,9.2 L107.5,32.9 L83.6,9.2 Z M114.3,40 L141.4,12.6 L197.9,69.6 L143.6,69.6 L114.3,40 Z M73.6,12.6 L100.9,40.2 L71.7,69.7 L17.2,69.7 L73.6,12.6 Z M79.1,75.2 L107.5,46.1 L135.9,75.2 L107.5,162.4 L79.1,75.2 Z M144.9,78.8 L197.5,78.8 L118.6,159.6 L144.9,78.8 Z M17.1,78.8 L70.2,78.8 L96.7,159.6 L17.1,78.8 Z",
    id: "Shape",
    fill: "url(#linearGradient-evcadxyh_c-1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataai);
export default __webpack_public_path__ + "static/media/Data.ai.044146b11e77a28a79ee6361f54aae2c.svg";
export { ForwardRef as ReactComponent };